import { updateTaskHtml } from '../../services/TaskService';
import { useCallback, useState } from 'react';

export const useUpdateTaskHtml = () => {
  const [isUpdatingHtml, setIsUpdatingHtml] = useState(false);
  const [updateHtmlError, setUpdateHtmlError] = useState(null);
  const [lastUpdatedTask, setLastUpdatedTask] = useState(null);

  const updateHtml = useCallback(async (taskId, html) => {
    setIsUpdatingHtml(true);
    setUpdateHtmlError(null);

    try {
      const result = await updateTaskHtml(taskId, html);
      setLastUpdatedTask(result);

      return {
        ok: true,
        data: result,
      };
    } catch (error) {
      console.error('Error actualizando HTML de la tarea:', error);
      setUpdateHtmlError(error);

      return {
        ok: false,
        error,
      };
    } finally {
      setIsUpdatingHtml(false);
    }
  }, []);

  return {
    updateHtml,
    isUpdatingHtml,
    updateHtmlError,
    lastUpdatedTask,
  };
};
